import { connect } from 'react-redux';

import {
  selectNavigatedFromOrToPageOne,
  selectRedirectedFromSearch,
} from 'src/components/organisms/ProductPages/modules/selectors';
import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectShowFeaturedProduct } from 'src/redux/products/selectors';
import { HeaderCopyBlock } from '../components/HeaderCopyBlock';

const mapStateToProps = (state: ReduxApplicationState) => ({
  categoryDescription: state.products.category!.description,
  navigation: state.products.navigation,
  categoryHeading: state.products.category!.heading,
  navigatedFromOrToPageOne: selectNavigatedFromOrToPageOne(state),
  openOnMount: !selectRedirectedFromSearch(state) && !selectShowFeaturedProduct(state),
});

export const HeaderCopyBlockContainer = connect(mapStateToProps)(HeaderCopyBlock);
